"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayModeToken = displayModeToken;
exports.displayWidthToken = displayWidthToken;
exports.platformToken = platformToken;
exports.themeToken = themeToken;
/**
 * Creates a display mode tokens object.
 */
function displayModeToken(tokens) {
    return { ...tokens, _resolveWithDisplayMode: true };
}
/**
 * Creates a display mode tokens object.
 */
function displayWidthToken(tokens) {
    return { ...tokens, _resolveWithDisplayWidth: true };
}
/**
 * Creates a display mode tokens object.
 */
function platformToken(tokens) {
    return { ...tokens, _resolveWithPlatform: true };
}
/**
 * Creates a display mode tokens object.
 */
function themeToken(property) {
    return { property, _resolveWithTheme: true };
}
